import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ProcurementService } from '../_services/procurement.service';
import { OvertimeService } from '../_services/overtime.service';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ]
})
export class TransferComponent {

  // Overtime sendErp
  overtimePeriod = '';
  overtimeLoading = false;

  // Vendor ERP
  vendorStep1Loading = false;
  vendorStep2Loading = false;

  // Item ERP
  itemStep1Loading = false;
  itemStep2Loading = false;

  constructor(
    private procurementService: ProcurementService,
    private overtimeService: OvertimeService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) {}

  // --- Fazla Mesai Aktar ---
  onOvertimeSendErp(): void {
    if (!this.overtimePeriod) {
      this.toastr.warning('Lütfen dönem seçiniz.', 'Uyarı');
      return;
    }
    this.confirmAndExecute(
      'Fazla Mesai Aktar',
      `${this.overtimePeriod} dönemi için fazla mesai aktarımını başlatmak istediğinize emin misiniz?`,
      () => {
        this.overtimeLoading = true;
        this.overtimeService.sendErp({ departmentId: -1, period: this.overtimePeriod }).subscribe({
          next: (res) => {
            this.overtimeLoading = false;
            const msg = res?.responseData?.item ?? 'Aktarım tetiklendi.';
            this.toastr.success(msg, 'Başarılı');
          },
          error: (err) => {
            this.overtimeLoading = false;
            const errorMsg = err?.error?.responseData?.item || err?.error?.msg || err?.message || 'Aktarım sırasında hata oluştu!';
            this.toastr.error(errorMsg, 'Hata');
          }
        });
      }
    );
  }

  // --- Tedarikçi İçeri Al ---
  onVendorSync(): void {
    this.confirmAndExecute(
      'Tedarikçi İçeri Al',
      'ERP\'den tedarikçi bilgilerini çekmek ve portale aktarmak istediğinize emin misiniz?',
      () => {
        this.vendorStep1Loading = true;
        this.procurementService.getErpVendors().subscribe({
          next: (res) => {
            this.vendorStep1Loading = false;
            const msg1 = res?.responseData?.item ?? 'Tedarikçi bilgileri çekildi.';
            this.toastr.info(msg1, 'Adım 1 - Tedarikçi Çek');

            this.vendorStep2Loading = true;
            this.procurementService.addNewErpVendors().subscribe({
              next: (res2) => {
                this.vendorStep2Loading = false;
                const msg2 = res2?.responseData?.item ?? 'Tedarikçiler güncellendi.';
                this.toastr.success(msg2, 'Adım 2 - Tedarikçi Aktar');
              },
              error: (err2) => {
                this.vendorStep2Loading = false;
                const errorMsg = err2?.error?.responseData?.item || err2?.error?.msg || err2?.message || 'Tedarikçi aktarımında hata oluştu!';
                this.toastr.error(errorMsg, 'Hata');
              }
            });
          },
          error: (err) => {
            this.vendorStep1Loading = false;
            const errorMsg = err?.error?.responseData?.item || err?.error?.msg || err?.message || 'Tedarikçi çekme sırasında hata oluştu!';
            this.toastr.error(errorMsg, 'Hata');
          }
        });
      }
    );
  }

  // --- Item İçeri Al ---
  onItemSync(): void {
    this.confirmAndExecute(
      'Item İçeri Al',
      'ERP\'den kalem bilgilerini çekmek ve portale aktarmak istediğinize emin misiniz?',
      () => {
        this.itemStep1Loading = true;
        this.procurementService.getErpItems().subscribe({
          next: (res) => {
            this.itemStep1Loading = false;
            const msg1 = res?.responseData?.item ?? 'Kalem bilgileri çekildi.';
            this.toastr.info(msg1, 'Adım 1 - Kalem Çek');

            this.itemStep2Loading = true;
            this.procurementService.addNewErpItems().subscribe({
              next: (res2) => {
                this.itemStep2Loading = false;
                const msg2 = res2?.responseData?.item ?? 'Kalemler güncellendi.';
                this.toastr.success(msg2, 'Adım 2 - Kalem Aktar');
              },
              error: (err2) => {
                this.itemStep2Loading = false;
                const errorMsg = err2?.error?.responseData?.item || err2?.error?.msg || err2?.message || 'Kalem aktarımında hata oluştu!';
                this.toastr.error(errorMsg, 'Hata');
              }
            });
          },
          error: (err) => {
            this.itemStep1Loading = false;
            const errorMsg = err?.error?.responseData?.item || err?.error?.msg || err?.message || 'Kalem çekme sırasında hata oluştu!';
            this.toastr.error(errorMsg, 'Hata');
          }
        });
      }
    );
  }

  private confirmAndExecute(title: string, message: string, onConfirm: () => void): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { title, message }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        onConfirm();
      }
    });
  }

  get anyLoading(): boolean {
    return this.overtimeLoading || this.vendorStep1Loading || this.vendorStep2Loading
      || this.itemStep1Loading || this.itemStep2Loading;
  }
}
